
import { Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { list_type, record_type, string_type, float64_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { createElement } from "react";
import React from "react";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { int32ToString, createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { append, toArray as toArray_1, map, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { toArray, map as map_1, length, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { useTranslation } from "react-i18next";
import { useLayoutEffectWithDeps } from "../fable_modules/Feliz.2.9.0/ReactInterop.js";
import { min, max } from "../fable_modules/fable-library-js.5.0.0-rc.2/Double.js";
import { createDisposable } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { GanttScale, GanttTaskType, GanttTask } from "../Bindings/Feliz.ReactGantt.js";
import { day } from "../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { Willow, Gantt as Gantt_1 } from "@svar-ui/react-gantt";

export class GanttBarSegment extends Record {
    constructor(LeftPercent, WidthPercent, ColorHex, Label) {
        super();
        this.LeftPercent = LeftPercent;
        this.WidthPercent = WidthPercent;
        this.ColorHex = ColorHex;
        this.Label = Label;
    }
}

export function GanttBarSegment_$reflection() {
    return record_type("Components.Gantt.GanttBarSegment", [], GanttBarSegment, () => [["LeftPercent", float64_type], ["WidthPercent", float64_type], ["ColorHex", string_type], ["Label", string_type]]);
}

export class GanttRow extends Record {
    constructor(Id, Label, Segments) {
        super();
        this.Id = Id;
        this.Label = Label;
        this.Segments = Segments;
    }
}

export function GanttRow_$reflection() {
    return record_type("Components.Gantt.GanttRow", [], GanttRow, () => [["Id", string_type], ["Label", string_type], ["Segments", list_type(GanttBarSegment_$reflection())]]);
}

function SegmentedBar(props) {
    let elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["relative", "w-full", "h-full"])], (elems = toList(delay(() => map((segment) => reactElement("div", {
        className: join(" ", ["absolute", "top-0", "h-full", "rounded-sm"]),
        title: segment.Label,
        style: {
            left: segment.LeftPercent + "%",
            width: segment.WidthPercent + "%",
            backgroundColor: segment.ColorHex,
        },
    }), props.data.customData))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function Gantt(props) {
    let elems_1, elems, children, props_2;
    const patternInput = useTranslation();
    const scrollerRef = reactApi.useRef(undefined);
    const patternInput_1 = reactApi.useState(480);
    useLayoutEffectWithDeps((_arg) => {
        const matchValue = scrollerRef.current;
        if (matchValue == null) {
        }
        else {
            const element = matchValue;
            const top = element.getBoundingClientRect().top;
            patternInput_1[1](max(256, ~~(window.innerHeight - top) - 72));
        }
        return createDisposable(() => {
        });
    }, [length(props.Rows)]);
    const tasks = map_1((row) => (new GanttTask(row.Id, 0, row.Label, "", props.StartDate, props.EndDate, "segmented", false, toArray(row.Segments))), props.Rows);
    let gridWidth;
    const texts = toArray_1(delay(() => append(map_1((_arg_1) => _arg_1.Label, props.Rows), delay(() => map_1((_arg_2) => _arg_2.header, props.Columns)))));
    gridWidth = min(400, max(140, ~~((() => { const ctx = document.createElement('canvas').getContext('2d'); ctx.font = '14px Inter, sans-serif'; return Math.max(...texts.map(t => ctx.measureText(t).width), 0); })()) + 48));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["gantt-scroller", "overflow-auto"])], ["ref", scrollerRef], ["style", {
        maxHeight: patternInput_1[0] + "px",
    }], (elems_1 = [reactElement("div", createObj(ofArray([["style", {
        height: ((length(props.Rows) * 32) + 76) + "px",
        width: "max-content",
        minWidth: "100%",
        overflow: "clip",
    }], (elems = [(children = ((props_2 = ofArray([["tasks", toArray(tasks)], ["taskTypes", [new GanttTaskType("segmented", "segmented")]], ["markers", toArray(props.Markers)], ["columns", toArray(props.Columns)], ["start", props.StartDate], ["end", props.EndDate], ["scales", [new GanttScale("month", 1, (date) => (date.toLocaleDateString((patternInput[1].language), { month: 'long', year: 'numeric' }))), new GanttScale("day", 1, (date_1) => int32ToString(day(date_1)))]], ["cellWidth", 28], ["cellHeight", 32], ["scaleHeight", 36], ["gridWidth", gridWidth], ["readonly", true], ["zoom", false], ["taskTemplate", (props_1) => createElement(SegmentedBar, props_1)]]), reactApi_1.createElement(Gantt_1, createObj(props_2)))), reactApi_1.createElement(Willow, {
        fonts: false,
        children: children,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

